import {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';

function HideJwtToken() {
  const {jwtToken} = useParams();

  let replace = useNavigate();

  useEffect(() => {
    if (jwtToken) {
      replace(`/area-riservata/dashboard`, {
        state: {
          jwtToken,
        },
      });
    }
  }, [jwtToken, replace]);

  return null;
}

export default HideJwtToken;
